<div class="flex flex-col gap-4 rounded-xl border border-solid border-primary-blue p-4 pb-6 shadow-card" [formGroup]="formGroup">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <lib-dropdown
        class="w-[312px]"
        [formControl]="formGroup.controls.descriptionDropdown"
        [options]="dropdownOptions()"
        [placeholder]="'health_history_health_history_tab_item_edit_dropdown_placeholder' | translate"
        overlayMaxHeight="228px"
        [overlayFlexible]="true"
        [error]="(formGroup.controls.descriptionDropdown.value | isTemporaryItem) && saveClicked()"
        [hint]="
          (formGroup.controls.descriptionDropdown.value | isTemporaryItem) && saveClicked()
            ? ('health_history_description_error' | translate)
            : ''
        "
      ></lib-dropdown>
      @if (!isOpenDental()) {
        <lib-radio-button-group
          [name]="healthHistoryItem().description"
          [options]="criticalStatusOptions"
          [formControl]="formGroup.controls.criticalStatus"
        ></lib-radio-button-group>
      }
    </div>
    @if (!isNewItem()) {
      <button
        class="btn-text-warn gap-[0.625rem] text-[0.875rem]"
        (click)="onDeleteClick()"
        [disabled]="isDeleteDisabled()"
        [libUiTooltip]="!deleteHealthHistoryEnabled() ? deleteDisabledTooltip : undefined"
        tooltipPosition="bottom"
      >
        <svg-icon [ngClass]="isDeleteDisabled() ? 'text-text-light' : 'text-states-red'" key="px-16-delete"></svg-icon>
        {{ 'health_history_health_history_tab_item_edit_delete' | translate }}
      </button>

      <ng-template #deleteDisabledTooltip>
        <div class="typo-h7-light max-w-[190px] whitespace-pre-wrap p-1">
          {{ 'health_history_delete_disabled_tooltip' | translate }}
        </div>
      </ng-template>
    }
  </div>
  <div class="flex items-center gap-2">
    @if (!isOpenDental()) {
      <lib-health-history-date-picker
        labelTranslationKey="health_history_health_history_tab_item_edit_reported"
        [formControl]="formGroup.controls.reportedDatePicker"
      ></lib-health-history-date-picker>
    }
    <lib-health-history-date-picker
      labelTranslationKey="health_history_health_history_tab_item_edit_started"
      [formControl]="formGroup.controls.startedDatePicker"
    ></lib-health-history-date-picker>
    <lib-health-history-date-picker
      labelTranslationKey="health_history_health_history_tab_item_edit_inactivated"
      [formControl]="formGroup.controls.inactivatedDatePicker"
      [minDate]="startedDateSignal() ?? undefined"
    ></lib-health-history-date-picker>
  </div>
  @if (editText()) {
    <lib-textarea-with-ai
      [formControl]="formGroup.controls.noteTextArea"
      [maxRows]="3"
      [isInputFocused]="true"
      [closeButtonDisabled]="isVoiceTyping()"
      (voiceTypingStatusChange)="onVoiceTypingStatusChange($event)"
      (closeClicked)="closeTextarea()"
    ></lib-textarea-with-ai>
  } @else {
    @if (formGroup.controls.noteTextArea.value) {
      <lib-text-with-show-more
        class="typo-h4-light font-light leading-5 text-text-secondary"
        [text]="formGroup.controls.noteTextArea.value"
        (textClick)="editText.set(true)"
      ></lib-text-with-show-more>
    } @else {
      <div
        class="flex items-center gap-2 rounded-2xl border border-solid border-text-extra-light p-3 leading-none text-text-light"
        (click)="editText.set(true)"
      >
        {{ 'health_history_note_placeholder' | translate }}
        <svg-icon class="max-h-4 max-w-4 text-text-light" key="px-16-voice-v-2"></svg-icon>
      </div>
    }
  }

  <div class="flex items-center justify-end gap-2">
    <button
      class="btn-secondary flex h-[32px] w-[100px] items-center gap-1"
      type="button"
      (click)="onCancelClick()"
      [disabled]="isLoading() || isVoiceTyping()"
    >
      <span class="typo-h5-semibold leading-none">{{ 'health_history_health_history_tab_item_edit_cancel' | translate }}</span>
    </button>
    <button
      class="btn-primary flex h-[32px] w-[100px] items-center gap-1"
      type="button"
      [disabled]="isLoading() || isVoiceTyping()"
      (click)="onSaveClick()"
    >
      @if (isLoading()) {
        <ng-lottie [options]="lottieOptions" currentColor class="mx-auto my-auto w-4"></ng-lottie>
      } @else {
        <svg-icon class="max-h-4 max-w-4 text-states-white" key="px-16-save"></svg-icon>
        <span class="typo-h5-semibold leading-none">{{ 'health_history_health_history_tab_item_edit_save' | translate }}</span>
      }
    </button>
  </div>
</div>
